var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AnalyzerTable',{attrs:{"headers":_vm.deviatedEndRateFromMarketTableHeaders,"get-table-data-action":"AnalyzerStore/getDeviatedEndRateFromMarket","table-data-getter":"AnalyzerStore/deviatedEndRateFromMarket"}})}
var staticRenderFns = []

export { render, staticRenderFns }